import React from 'react';
import { Settings } from 'lucide-react';
interface HeaderProps {
  onSettingsClick?: () => void;
  showSettings?: boolean;
}
export function Header({
  onSettingsClick,
  showSettings = true
}: HeaderProps) {
  return <header className="flex items-center justify-between p-4 bg-white/80 backdrop-blur-sm border-b border-sky-100" data-id="element-111">
      <div className="flex items-center gap-2" data-id="element-112">
        <div className="w-8 h-8 bg-gradient-to-br from-sky-400 to-purple-400 rounded-full flex items-center justify-center" data-id="element-113">
          <span className="text-white text-lg" data-id="element-114">✦</span>
        </div>
        <h1 className="text-xl font-semibold text-slate-800" data-id="element-115">SoulLift</h1>
      </div>
      {showSettings && <button onClick={onSettingsClick} className="p-2 rounded-full hover:bg-sky-50 transition-colors focus:outline-none focus:ring-2 focus:ring-sky-400" aria-label="Open settings" data-id="element-116">
          <Settings className="w-5 h-5 text-slate-600" data-id="element-117" />
        </button>}
    </header>;
}